import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
    if (config.data && typeof config.data === 'object') {
        //config.data.tabId = getTabId();
    }
    return config;
});

export default axiosInstance;